import React from 'react';
import classes from './DisplayBox.css';

const displayBox = (props) => (
    <div className={classes.DisplayBox}>
        <div className={classes.DisplayBoxTopBorder}></div>
        <div className={classes.DisplayBoxContent}>
            {props.children}
        </div>
    </div>

);

export default displayBox;